import { useInterval } from 'ahooks';
import { useState } from 'react';

import Button from '@/components/button';

import styles from './styles.module.less';

export const Timeout = ({
  onSend,
  sending,
  type = 'default',
  disabled
}: {
  onSend: () => Promise<boolean>;
  sending: boolean;
  disabled: boolean;
  type?: 'default' | 'info' | 'success';
}) => {
  const [count, setCount] = useState(60);
  const [interval, setInterval] = useState<number | undefined>();

  const clear = useInterval(() => {
    if (count <= 0) {
      setInterval(undefined);
      clear();
      return;
    }
    setCount(count - 1);
  }, interval);

  const onStart = async () => {
    const result = await onSend();

    if (result) {
      setInterval(1000);
      setCount(60);
    }
  };

  return (
    <div className={styles.coderight}>
      {interval ? (
        <Button block disabled>
          {count}s
        </Button>
      ) : (
        <Button disabled={disabled || sending} htmlType="button" type={type} onClick={onStart} block>
          SMS
        </Button>
      )}
    </div>
  );
};
